import axios from '@/config/axios.config';
import Vars from '@/config/vars';
import { logEvent, logException } from '@/helpers/cieloLogger';
import mockedBanks from '@/mockedBanks';

export default {
    namespaced: true,

    state: {
        selectedBank: null,
        bankRedirectModal: false,
        bankRedirectUrl: null,
        paymentDate: null,
        institutions: [],
    },

    getters: {
        getSubmitModel(state, getters, rootState, rootGetters) {
            const submitModel = {
                OpenFinanceAuthorizationServerId: state.selectedBank.authorizationServerId
            };

            return submitModel;
        },

        getSelectedBank: state => state.selectedBank,

        getBankRedirectModal: state => state.bankRedirectModal,

        getBankRedirectUrl: state => state.bankRedirectUrl,

        getPaymentDate: state => state.paymentDate,

        getInstitutions: (state) => state.institutions,
    },

    mutations: {
        setSelectedBank(state, bank) {
            state.selectedBank = bank;

            state.paymentDate = getCurrentDate();
        },

        setSubmitResponse(state, response) {
            state.bankRedirectUrl = response.OpenFinanceRedirectUrl;
        },

        openBankRedirectModal(state) {
            state.bankRedirectModal = true;
        },

        resetSelectedBank(state) {
            state.selectedBank = null;
        },

        setInstitutions(state, institutions) {
            state.institutions = institutions;
        }
    },

    actions: {
        async fetchInstitutions({ commit, rootState }) {
            let preorder = rootState.preorder.Id;

            try {
                let response;

                if (Vars.USE_SIMULATED_MODE)
                    response = await new Promise(resolve => setTimeout(() => resolve({ data: mockedBanks }), 3000));
                else
                    response = await axios.get(`/itp/institutions/${preorder}`);

                let data = response.data;

                commit('setInstitutions', data);

                logEvent({
                    category: 'Institutions',
                    action: 'Fetch Institutions',
                    label: 'Institutions carregadas com sucesso'
                });
            } catch (error) {
                logException(error);
            }
        }
    },
};


function getCurrentDate() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}`;
}
